import { render, staticRenderFns } from "./prestamoMaterialesIndex.vue?vue&type=template&id=7980bc1c&scoped=true&"
import script from "./prestamoMaterialesIndex.vue?vue&type=script&lang=ts&"
export * from "./prestamoMaterialesIndex.vue?vue&type=script&lang=ts&"
import style0 from "./prestamoMaterialesIndex.vue?vue&type=style&index=0&id=7980bc1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980bc1c",
  null
  
)

export default component.exports